import type { ErrorComponentProps } from '@tanstack/react-router';
import { Link, rootRouteId, useMatch, useRouter } from '@tanstack/react-router';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { Button } from '@/components/ui';
import logger from '@/lib/logger';
import { showErrorToast } from '@/lib/toast';
import { ErrorActions } from './catch-boundary.styles';

function ErrorFallback({ error }: FallbackProps) {
  const message = error instanceof Error ? error.message : String(error);
  showErrorToast(message);
  return null;
}

const CatchBoundary = ({ error }: ErrorComponentProps) => {
  const router = useRouter();
  const isRoot = useMatch({
    strict: false,
    select: (state) => state.id === rootRouteId,
  });

  logger.error(error);

  const handleRetry = () => {
    router.invalidate();
  };

  const handleGoBack = () => {
    window.history.back();
  };

  let secondaryAction = (
    <Link to="/">
      <Button text="Home" variant="outlined" size="medium" />
    </Link>
  );
  if (!isRoot) {
    secondaryAction = <Button text="Go back" variant="outlined" size="medium" onClick={handleGoBack} />;
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ErrorActions>
        <Button text="Try again" size="medium" onClick={handleRetry} />
        {secondaryAction}
      </ErrorActions>
    </ErrorBoundary>
  );
};

export default CatchBoundary;
